import buildUrl from 'build-url';
import queryString from 'query-string';
import useRouter from '../../../../hooks/useRouter';
import useBellaPush from '../../../../hooks/useBellaHistoryPush';
import { getQueryParameterValue } from '../../../ListingPage/services/listingPageUrlService';

export type SetPpdStateFunc = (state: Partial<PDPUrlState>) => void;

interface PDPUrlState {
    pdpUrlIdentifier: string;
    activeSimpleSku?: string;
}

const convertUrlToPDPState = (pathname: string, search: string) => {
    const query = queryString.parse(search);
    const activeSimpleSku = getQueryParameterValue(query, 'simple');

    return {
        pdpUrlIdentifier: pathname,
        activeSimpleSku,
    };
};

export const convertPdpStateToUrl = (pdpPageState: PDPUrlState, host: string = '') => {
    const { pdpUrlIdentifier, activeSimpleSku: simple } = pdpPageState;
    const queryParams = simple ? { simple } : undefined;
    return buildUrl(host, { path: pdpUrlIdentifier, queryParams });
};

const usePdpUrlState = (): [PDPUrlState, SetPpdStateFunc] => {
    const { location } = useRouter();
    const bellaPush = useBellaPush();

    const { pathname, search } = location;
    const pdpPageState = convertUrlToPDPState(pathname, search);

    const setPdpPageState: SetPpdStateFunc = state => {
        const url = convertPdpStateToUrl({ ...pdpPageState, ...state });
        bellaPush(url);
    };

    return [pdpPageState, setPdpPageState];
};

export default usePdpUrlState;
